import React from 'react';
import { Modal, Button, Typography, Space } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const DeleteConfirmModal = ({ visible, onCancel, onConfirm, itemType, itemName, description }) => {
  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      width={480}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      destroyOnClose
      footer={null}
      style={{
        borderRadius: '12px'
      }}
      styles={{
        mask: {
          backgroundColor: 'rgba(0, 0, 0, 0.65)',
          backdropFilter: 'blur(8px)'
        },
        body: {
          padding: '32px',
          borderRadius: '12px'
        }
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '64px',
          height: '64px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px auto'
        }}>
          <DeleteOutlined style={{ fontSize: '28px', color: '#dc2626' }} />
        </div>
        
        <Title level={3} style={{ margin: '0 0 12px 0', color: '#171717' }}>
          Delete {itemType}?
        </Title>
        
        <Text style={{ fontSize: '16px', color: '#737373', display: 'block', marginBottom: '8px' }}>
          Are you sure you want to delete this {itemType.toLowerCase()}?
        </Text>
        
        <Text strong style={{ fontSize: '18px', color: '#171717', display: 'block', marginBottom: '24px' }}>
          "{itemName}"
        </Text>
        
        {description && (
          <Text type="secondary" style={{ fontSize: '14px', display: 'block', marginBottom: '32px' }}>
            {description}
          </Text>
        )}
        
        <Space size="large" style={{ width: '100%', justifyContent: 'center' }}>
          <Button
            size="large"
            onClick={onCancel}
            style={{
              borderRadius: '8px',
              height: '44px',
              minWidth: '120px',
              fontWeight: 500
            }}
          >
            Cancel
          </Button>
          <Button
            danger
            size="large"
            icon={<DeleteOutlined />}
            onClick={onConfirm}
            style={{
              borderRadius: '8px',
              height: '44px',
              minWidth: '120px',
              fontWeight: 175,
              background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
              border: 'none',
              color: '#ffffff'
            }}
          >
            Delete
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;
